<template>
  <div class="center">
    <pull-to :top-load-method="downRefreshTwo" :bottom-load-method="upRefreshTwo" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0>
      <div class="headline">
            <!-- left -->
          <div class="head-left">
              <div class="head-left-top font-tex3">{{ headDate.contract_name }}</div>
              <div v-if="headDate.area_name" class="head-left-bot font-tex1">
                  <div class="left-bot-text">
                      <!-- <div>83区域：</div> -->
                      <div>{{headDate.area_name }}</div>
                  </div>
                  <div class="left-bot-text">
                      <div>平台商：</div>
                      <div>{{headDate.platform }}</div>
                  </div>
              </div>
              <div class="head-left-bot font-tex1 text-color">
                  <div class="left-bot-text">
                      <div>已验收项目：</div>
                      <div>{{ headDate.contract_num }}</div>
                  </div>
                  <div class="left-bot-text">
                      <div>问题数：</div>
                      <div>{{ headDate.problem_num }}</div>
                  </div>
              </div>
          </div>
          <!-- right -->
          <!-- <div class="head-right font-text">问题数 12</div> -->
      </div>
      <!-- cntent -->
      <div v-if="true" class="centent">
            <!-- search -->
            <div class="search">
               <input v-model="parmse.search_info" placeholder="输入您想搜索的巡检内容" type="text" />
               <img @click="search" src="~@/assets/images/user/house/sousuo.png" alt="">
            </div>
          <!-- box -->
            <div v-for="(item, index) in itemList" :key="index" class="box" @click="getRectify(item,index)">
                <!-- user -->
                <div class="box-user">
                    <div class="box-user-left">
                        <img v-if="item.user_info.gender != 1" :src="item.user_info.gender" alt="">
                        <img v-else src="~@/assets/images/user/house/avtH.png" alt="">
                    </div>
                    <div class="box-user-cen">
                        <div class="user-top">
                            <div class="font-tex3">{{ item.user_info.user_name }}</div>
                            <!-- <img src="~@/assets/images/user/house/user_vip1_img.png" alt=""> -->
                        </div>
                        <div class="font-text1 omit user-bot">{{ item.user_info.useraddress }}</div>
                    </div>
                    <!-- <div class="box-user-right">
                        <div>{{ item.user_info.score }}</div>
                        <div class="font-text1">综合得分</div>
                    </div> -->
                </div>
                <!-- time -->
                <!-- <div class="box-time">
                    <div class="time-top font-tex2">
                        <div>开工时间：{{ item.start_date }}</div>
                        <div>完工时间：{{ item.finish_date }}</div>
                    </div>
                    <div class="font-text1 time-bot">合同号：{{ item.contract_code }}</div>
                </div> -->

                <div v-for="(item1, index1) in item.rectify" :key="index1" :class="[ index1 == 0 ? 'item-top-bor' : '', 'item-box-category']">
                        <!-- 大类区分 -->
                        <div class="category">{{ item1.parent_name }}</div>
                        <!-- 子类区分 -->
                        <div v-for="(item2, index2) in item1.child_list" :key="index2" class="subclass">
                            <div class="subclass-titile">{{ item2.child_name }}</div>
                            <div v-for="(item7, index7) in item2.acceptacne_list" :key="index7">
                                <!-- remold 整改前-->
                                <div  class="remold remoldOne">
                                    <!-- buttom -->
                                    <div class="rem-btn btn-one font-text">整改前</div>
                                    <!-- titile -->
                                    <div class="rem-title">
                                        <div>{{ item7.list.before.acceptance_name }}</div>
                                        <div>{{ item7.list.before.new_result }}</div>
                                    </div>
                                    <!-- img -->
                                    <div class="rem-img">
                                        <template v-for="(item4, index4) in item7.list.before.photo_list">
                                            <div @click="openLook(item4)" :key="index4" v-if="index4 < 3"><img :src="item4" alt=""></div>
                                        </template>
                                    </div>

                                    <!-- odd -->
                                    <div class="rem-odd font-tex2">
                                        <div>工单号：{{ item7.list.before.project_message.new_name }}</div>
                                        <div>施工时间：{{ item7.list.before.project_message.new_actualstartedon }}至{{ item7.list.before.project_message.new_actualfinishedon }}</div>
                                        <div>施工负责人：{{ item7.list.before.project_message.project_manager_name }}</div>
                                    </div>
                                </div>
                                <!-- remold 整改后-->
                                <div  class="remold">
                                    <!-- buttom -->
                                    <div class="rem-btn btn-tow font-text">整改后</div>
                                    <!-- titile -->
                                    <div class="rem-title">
                                        <div class="div-text">{{ item7.list.after.acceptance_name }}</div>
                                        <div>{{ item7.list.after.new_result }}</div>
                                    </div>
                                    <!-- img -->
                                    <div class="rem-img">
                                        <template v-for="(item6, index6) in item7.list.after.photo_list" >
                                            <div @click="openLook(item6)" :key="index6" v-if="index6 < 3"><img :src="item6" alt=""></div>
                                        </template>
                                    </div>
                                    <!-- odd -->
                                    <div class="rem-odd font-tex2">
                                        <div>验收工单号：{{ item7.list.after.project_message.new_name }}</div>
                                        <div>验收时间：{{ item7.list.after.project_message.new_actualstartedon }}</div>
                                        <div>整改完工时间：{{ item7.list.after.project_message.new_actualfinishedon }}</div>
                                        <div>验收负责人：{{ item7.list.after.project_message.check_name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
      </div>
      <!-- 悬浮按钮 -->
      <Drag></Drag>
      <!-- 预览图片 -->
      <van-image-preview v-model="show" :startPosition="lookImgIndex" :images="images">
          <template v-slot:imgIndex>第{{ imgIndex }}页</template>
      </van-image-preview>
    </pull-to>
  </div>
</template>

<script>
import Drag from '../components/drag.vue';
import PullTo from "vue-pull-to";
import common from "@/common/common";
export default {
    components: {
        Drag,
        PullTo
    },
    data () {
        return {
            parmse: {  // 参数
                service_id  :'',
                child_id :'',
                acceptance_id :'',
                company_id: '',
                search_info: '',
                page: 0,
                limit: 10
            },
            headDate: {  // 项目介绍数据
                contract_name: '',
                area_name: '',
                platform: '',
                contract_num: '',
                problem_num: ''
            },
            total: 0, // 列表总页数
            itemList: [],    // 列表数据

            imgUrl: {}, // 图片
            show: false,
            imgIndex: 0,
            lookImgIndex: 0,
            images: [],
        }
    },
    created () {
      // 判断是全国跳转来的还是服务商
      if(this.$route.query.isWholeCountry=='true'){
       const { company_id, contract_num, problem_num, company_name} = JSON.parse(this.$route.query.id);

       this.headDate.contract_name = company_name;
       this.headDate.contract_num = contract_num;
       this.headDate.problem_num = problem_num;
       this.parmse.company_id = company_id;
       $init(() => {
            Promise.all([
                this.$userHouse.dispatch("getDetails", this.parmse)
            ]).then((res) => {

                let newArr = this.$userHouse.state.scoreDeails;
                this.itemList = newArr.list;
                console.log(this.itemList ,'列表')
                this.total = newArr.total;    // 数据总条数
                if(newArr.platform_info.area_name) {
                    this.headDate.area_name = newArr.platform_info.area_name;
                    this.headDate.platform = newArr.platform_info.platform_name;
                }

                this.$store.commit("loadSwitch", false);// 页面loading关闭
            });
       })
      }else{
        console.log(this.$route.query.id)
          const { company_id,nQuestionTypeId,serviceId,processId } = JSON.parse(this.$route.query.id);
          this.parmse.company_id = company_id;
          this.parmse.service_id   = nQuestionTypeId;
          this.parmse.child_id   = processId;
          this.parmse.acceptance_id  = serviceId;
          $init(() => {
            Promise.all([
                this.$userHouse.dispatch("getDetails", this.parmse)
            ]).then((res) => {

                let newArr = this.$userHouse.state.scoreDeails;
                this.itemList = newArr.list;
                console.log(this.itemList ,'列表')
                this.total = newArr.total;    // 数据总条数
                if(newArr.platform_info.area_name) {
                    this.headDate.area_name = newArr.platform_info.area_name;
                    this.headDate.platform = newArr.platform_info.platform_name;
                }
                this.headDate.contract_name = newArr.platform_info.name;
                this.headDate.contract_num =  newArr.platform_info.contract_num;
                this.headDate.problem_num =  newArr.platform_info.problem_num;

                this.$store.commit("loadSwitch", false);// 页面loading关闭
            });
          })
      }

    },
    methods: {
        getRectify(item,index){
            if(JSON.stringify(item.rectify)!=='[]')return //没有数据的时候才请求
            this.$store.commit("loadSwitch", true);
            this.$store.dispatch({type:'serviceScoreDetail/getScoreDataV2',contract_id:item.contract_id}).then ((res) => {
                console.log(res.data.data.result[item.contract_id],'数据')
                this.itemList[index].rectify=res.data.data.result[item.contract_id]
                this.$store.commit("loadSwitch", false);
            })
        },
        openLook(index) {   // 点击预览图片
            this.show = true;
            this.images = [index];
        },
        dataSet(loaded) {   // 数据
            Promise.all([
                this.$userHouse.dispatch("getDetails", this.parmse)
            ]).then((res) => {
                this.itemList = [...this.$userHouse.state.scoreDeails.list, ...this.itemList];
                if(loaded) return loaded("done");
            });
        },
        search() {  // 搜索
            console.log(this.parmse, '搜索');
            this.itemList = [];      // 清空数据
            this.dataSet();
        },
         //下拉
        downRefreshTwo(loaded) {
            this.parmse.search_info = '';
            this.parmse.page = 0;
            this.itemList = [];      // 清空数据
            this.dataSet(loaded);
        },
        //上拉
        upRefreshTwo(loaded) {
            // 获取数据的总页数
            let pageSize = common.pageCount(this.total, this.parmse.limit);
            if (this.parmse.page >= pageSize) {
                this.$toast("到底了~");
                loaded("done");
            } else {
                this.parmse.page++;
                this.dataSet(loaded);
            }
        },
    }
}
</script>

<style lang="scss" scoped>
.center {
    width: 100%;
    background: $userBg;
    height: 100vh !important;
    overflow: hidden;

    -webkit-animation: fadeleftIn .4s;
    animation: fadeleftIn .4s;
    .headline {
        padding: 36px 28px 50px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: $defaultBackgroundGary linear-gradient(135deg, #58AF71 0%, #419454 100%) no-repeat left top / 100% 100%;
        .head-left {
            flex: 1;
            .head-left-top {
                color: $divBg;
            }
            .head-left-bot {
                color: $divBg;
                opacity: 0.8;

                display: flex;
                justify-content: space-between;
                margin-top: 14px;
                .left-bot-text {
                    display: flex;
                    align-items: baseline;
                    div:last-of-type{
                        width: 200px;
                        white-space: pre-wrap;

                        display: flex;
                        align-items: center;
                    }
                }
            }
            .text-color {
                opacity: 1 !important;

            }
        }
        .head-right {
            width: 210px;
            height: 88px;
            text-align: center;
            line-height: 88px;
            background: #3C824D;
            border-radius: 12px;

            color: $divBg;
        }
    }
    .centent {
        padding: 0 24px 36px 24px;
        margin-top: -24px;
        .search {
            padding: 0 28px;
            height: 80px;
            background: $divBg;
            box-shadow: 0px 4px 8px 0px rgba(228, 228, 228, 0.5);
            border-radius: 12px;

            display: flex;
            align-items: center;
            justify-content: space-between;

            img {
                width: 40px;
                height: 40px;
            }

            input {
                width: 100%;
                padding-right: 20px;
                box-sizing: border-box;
                color: #A2A2A2;

                font-size: 28px;
                font-weight: 400;
            }
        }
        .box {
            margin-top: 28px;
            padding: 28px 24px;
            background: $divBg;
            border-radius: 12px;
            .box-user {
                display: flex;
                align-items: center;
                padding-bottom: 28px;
                border-bottom: 1px solid rgba(245, 245, 245, 1);
                .box-user-left {
                    width: 84px;
                    height: 84px;
                    border-radius: 50%;
                    margin-left: 4px;
                    overflow: hidden;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .box-user-cen {
                    padding-left: 20px;
                    flex: 1;
                    .user-top {
                        display: flex;
                        align-items: center;
                        padding-bottom: 8px;
                        div {
                            color: $deepGreen;
                        }
                        img {
                            margin-left: 12px;
                            width: 92px;
                            height: 40px;
                        }
                    }
                    .user-bot {
                        max-width: 550px;
                        color: $comText1;
                    }
                }
                .box-user-right {
                    text-align: center;
                    color: $deepGreen;
                    div:first-of-type{
                        font-size: 52px;
                        font-weight: 500;

                        height: 84px;
                        line-height: 84px;
                    }
                    div:last-of-type{
                        margin-top: -16px;
                    }
                }
            }
            .box-time {
                padding: 22px 0 32px 0;
                .time-top {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: 20px;
                }
                .time-bot {
                    color: $comText1;
                }
            }
            .item-box-category {
                margin-top: 40px;
                border-top: 1px solid rgba(71, 154, 91, 0.4);
                .category {
                    margin-top: 20px;
                    font-size: 36px;
                    font-weight: 500;
                    color: #318544;
                }
                .subclass {
                    .subclass-titile {
                        margin-top: 20px;
                        font-size: 32px;
                        font-weight: 500;
                        color: #444444;
                    }
                    .remold {
                        border-top: 1px dashed rgba(0, 0, 0, 0.1);
                        margin-top: 20px;
                        .rem-btn {
                            width: 148px;
                            height: 60px;
                            text-align: center;
                            line-height: 60px;
                            border-radius: 8px;

                            margin-top: 34px;
                        }
                        .btn-one {
                            background: #E7EDE8;
                            color: $deepGreen;
                        }
                        .btn-tow {
                            background: $deepGreen;
                            color: $divBg;
                        }
                        .rem-title {
                            margin-top: 28px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            div:first-of-type{
                                font-size: $bigSize;
                                font-weight: 400;
                            }
                            div:last-of-type{
                                font-size: $baseSize;
                                font-weight: 500;
                                color: $warnText;
                            }
                            .div-text {
                                color: $deepGreen;
                            }
                        }
                        .rem-img {
                            margin-top: 20px;
                            display: flex;
                            align-items: center;
                            div{
                                width: 160px;
                                height: 160px;
                                background: #F3F3F3;
                                border-radius: 12px;
                                overflow: hidden;
                                margin-right: 24px;
                                img {
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                        }
                    }
                }
            }
            .item-top-bor {
                 margin-top: 0 !important;
                border-top: none !important;
            }
            .remoldOne{
                margin-top: 0px;
            }
            .rem-odd {
                margin-top: 32px;
                div{
                    padding-top: 16px;
                }
                div:first-of-type{
                    padding-top: 0;
                }
            }
        }
    }
}
// 卡片标题字号 - 14 个样式
.font-text {  // 28
    font-size: $baseSize;
    font-weight: 500;
}
.font-text1 { // 24
    font-size: $smallSize;
    font-weight: 400;
}
.font-tex2 {  // 28
    font-size: $baseSize;
    font-weight: 400;
}
.font-tex3 {  // 32
    font-size: $bigSize;
    font-weight: 500;
}
.font-text5 { // 24
    font-size: $smallSize;
    font-weight: 500;
}
// 超出一行省略
.omit {
    // overflow: hidden;
    // text-overflow:ellipsis;
    // white-space: nowrap;
}
// 超出2行省略
.omit-s {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
@keyframes fadeleftIn {
    0% {
        -webkit-transform: translate3d(100%, 0, 0);
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }
    100% {
        -webkit-transform: none;
        transform: none;
    }
}

@-webkit-keyframes fadeleftIn {
    0% {
        -webkit-transform: translate3d(100%, 0, 0);
    }
    100% {
        -webkit-transform: none;
    }
}
</style>
